"use strict";
import { useQuery } from "@tanstack/react-query";
import { TOPAZ_STATS_API_ENABLED, fetchStatsGauges } from "api/topazStats/client";
import { UniverseChainId } from "features/chains/types";
const FIFTEEN_MINUTES_MS = 15 * 60 * 1e3;
const EMPTY_POOL_TO_GAUGE = /* @__PURE__ */ new Map();
const EMPTY_GAUGE_BY_POOL = /* @__PURE__ */ new Map();
export function useTopazStatsGauges(chainId, enabled = true) {
  const apiEnabled = TOPAZ_STATS_API_ENABLED && enabled && chainId === UniverseChainId.Mainnet;
  const { data, isLoading, isError, isSuccess } = useQuery({
    queryKey: ["topazStatsGauges", chainId],
    queryFn: async () => {
      const gauges = await fetchStatsGauges();
      const poolToGaugeMap = /* @__PURE__ */ new Map();
      const gaugeByPool = /* @__PURE__ */ new Map();
      for (const gauge of gauges) {
        if (!gauge.poolAddress || !gauge.gaugeAddress) {
          continue;
        }
        const poolKey = gauge.poolAddress.toLowerCase();
        poolToGaugeMap.set(poolKey, gauge.gaugeAddress);
        gaugeByPool.set(poolKey, gauge);
      }
      return { poolToGaugeMap, gaugeByPool };
    },
    enabled: apiEnabled,
    staleTime: FIFTEEN_MINUTES_MS,
    refetchInterval: FIFTEEN_MINUTES_MS,
    retry: 1
  });
  return {
    poolToGaugeMap: data?.poolToGaugeMap ?? EMPTY_POOL_TO_GAUGE,
    gaugeByPool: data?.gaugeByPool ?? EMPTY_GAUGE_BY_POOL,
    isLoading: apiEnabled && isLoading,
    isError,
    isSuccess
  };
}
